// Module-level singleton: the cover image that bridges the index → project transition.
// Index.vue sets it before navigating; Project.vue clears it once the first slide has painted.
import { ref } from 'vue'

const cover = ref(null)

export const transitionCover = cover
export const setTransitionCover = (c) => { cover.value = c }
export const clearTransitionCover = () => { cover.value = null }
